module.exports = __webpack_public_path__ + "img/emptyrateGroup 6028.9aa7d6aa.svg";